<template>
  <div class="icon-wrap-container" :class="{'hover': isExpand}" @mouseenter="onCategoryHoverEnter" @mouseleave="onCategoryHoverLeave">
    <div class="icon-wrap" :class="[isCategoryNotEtc(category, 2) ? category : 'etc', seeAll && 'seeAll']">
      <i v-if="!isExpand" class="icon" :class="[isCategoryNotEtc(category, 2) ? `icon-${category}` : 'icon-etc']"></i>
      <p v-if="!isExpand && seeAll" class="secondary-title">{{ findCategoryName(category, 2) }}</p>
      <template v-if="isExpand">
        <div :class="isExpand && 'expand'">
          <div class="secondary">
            <i class="icon" :class="[isCategoryNotEtc(category, 2) ? `icon-${category}` : 'icon-etc']"></i>
            <p class="secondary-title">{{ findCategoryName(category, 2) }}</p>
          </div>
          <div class="line"></div>
          <div class="detail-wrap">
            <template v-if="category2 && category2.length !== 0">
              <div class="tertiary" v-for="(item, index) in category2" :key="index" >
                <i class="icon" :class="[isCategoryNotEtc(item, 3) ? `icon-tertiary-${item}` : 'icon-etc']"></i>
                <p class="tertiary-title">{{ findCategoryName(item, 3) }}</p>
              </div>
            </template>
            <template v-else>
              <div class="tertiary" >
                <p class="tertiary-title">{{ $t(`common.category3.noData`) }}</p>
              </div>
            </template>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {
  AI_CATEGORY_SECONDARY,
  AI_CATEGORY_TERTIARY
} from '@/libs/constants'

export default {
  name: 'CategoryIcon',
  props: {
    category: {
      type: String,
      default: ''
    },
    category2: {
      type: Array
    },
    seeAll: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isExpand: false,
      isProcessing: false
    }
  },
  computed: {
  },
  methods: {
    findCategoryName (name, type) {
      switch (type) {
        case 2:
          if (AI_CATEGORY_SECONDARY.find((item) => item === name)) {
            return this.$t(`common.category2.${name}`)
          } else {
            return this.$t(`common.category2.etc`)
          }
        case 3:
          if (AI_CATEGORY_TERTIARY.find((item) => item === name)) {
            return this.$t(`common.category3.${name}`)
          } else {
            return this.$t(`common.category3.etc`)
          }
        default:
          return this.$t(`common.category2.etc`)
      }
    },
    isCategoryNotEtc (name, type) {
      return this.findCategoryName(name, type) !== this.$t(`common.category2.etc`)
    },
    onCategoryHoverEnter (e) {
      e.stopPropagation()
      if (!this.isExpand && !this.isProcessing) {
        this.isProcessing = true
        this.isExpand = true
        this.$emit('onCategoryHover', this.isExpand)
        this.isProcessing = false
      }
    },
    onCategoryHoverLeave (e) {
      e.stopPropagation()
      if (this.isExpand && !this.isProcessing) {
        this.isProcessing = true
        this.isExpand = false
        this.$emit('onCategoryHover', this.isExpand)
        this.isProcessing = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/fonts/fontIcon.css';

.icon-wrap-container {
  position: absolute;
  top: 37%;
  left: -13px;
  z-index: 5;
  cursor: initial;

  .icon-wrap {
    @include flexYcenter;
    border-radius: 5px;
    padding: 5px;
    box-sizing: border-box;
    max-width: 203px;
    max-height: 36px;
    width: 100%;
    height: 100%;
    vertical-align: middle;
    border: 1px solid rgba(255, 255, 255, 0.80);
    opacity: 0.9;
    transition: all .3s ease;
    transform-origin: 0;
    color: #222;
    width: max-content;
    .icon {
      @include flexXYcenter;
      opacity: 1;
      font-size: 26px;
      margin-bottom: 1px;
    }

    &.seeAll {
      padding: 5px 12px 5px 5px;

      .secondary-title {
        margin-left: 6px;
        color: #222;
        font-size: 13px;
        font-weight: 700;
        line-height: 120%;
        line-height: 1;
      }
    }

    .expand {
      display: none;
    }

  }
  &.hover {
    .icon-wrap {
      padding: 12px;
      max-width: 336px;
      max-height: 100%;
      width: 100%;
      height: 100%;
      overflow: hidden;

      .expand {
        display: block;
        max-width: 280px;
        width: 100%;
        .secondary {
          width: 280px;
          display: flex;

          .secondary-title {
            margin-top: 4px;
            margin-left: 6px;
            color: #222;
            font-size: 16px;
            font-weight: 600;
            line-height: 120%;
          }
        }

        .line {
          height: 1px;
          width: 100%;
          background: rgba(34, 34, 34, 0.30);
          margin-top: 14px;
          margin-bottom: 10px;
        }

        .detail-wrap {
          width: 280px;
          padding-left: 5px;
          .tertiary {
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 11px;
            margin-bottom: 6px;

            .icon {
              font-size: 16px;
            }

            .tertiary-title {
              flex-grow: 1;
              width: 100%;
              color: #222;
              font-size: 13px;
              font-weight: 500;
              line-height: 120%; /* 15.6px */
              word-break: keep-all;
              white-space: normal;
            }
          }
        }
      }
    }
  }
}
</style>
